import $  from 'jquery';


function accordion(){
    $('.accordion').each(function () {
        let block = $(this);
        block.find('.accordion-item').each(function () {
            let header = $(this).find('.accordion-item__header');
            let content = $(this).find('.accordion-item__content');
    
            header.on('click', function () {
                // Close all accordion items except the clicked one
                block.find('.accordion-item__content').not(content).slideUp();
                block.find('.accordion-item__header').not(header).removeClass('active');
                
                // Toggle the visibility of the content of the clicked item
                content.slideToggle();
                
                // Optional: Add a class to the header to indicate its state (open/closed)
                header.toggleClass('active');
            });
        });
    });
}


export { accordion };